import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// Dynamic topic suggestions — 3 frames: AI chips appear -> click -> topic
// populated.
function BSChips(): JSX.Element {
  return (
    <SimShell step={1} total={3} title="Suggestion chips">
      <div className="flex flex-wrap gap-1.5">
        {['race-week tapers', 'sleep + recovery', 'mid-run fuel', 'electrolyte basics'].map((c) => (
          <span
            key={c}
            className="rounded-full border border-accent/40 bg-accent/10 text-accent text-[11px] px-2 py-0.5"
          >
            {c}
          </span>
        ))}
      </div>
      <div className="mt-1.5 text-[10px] font-mono text-dash-muted">
        per-site, 24-hour cache, Refresh to regenerate
      </div>
    </SimShell>
  );
}

function BSClick(): JSX.Element {
  return (
    <SimShell step={2} total={3} title="Click a chip">
      <div className="flex flex-wrap gap-1.5">
        {['race-week tapers', 'mid-run fuel'].map((c, i) => (
          <span
            key={c}
            className={
              'rounded-full text-[11px] px-2 py-0.5 border ' +
              (i === 1
                ? 'border-accent bg-accent/20 text-accent'
                : 'border-accent/40 bg-accent/10 text-accent')
            }
          >
            {c}
          </span>
        ))}
      </div>
    </SimShell>
  );
}

function BSPopulated(): JSX.Element {
  return (
    <SimShell step={3} total={3} title="Topic populated">
      <label className="text-[11px] font-mono uppercase tracking-wide text-dash-muted">Topic</label>
      <div className="mt-1 rounded border border-dash-border bg-dash-surface px-3 py-2 text-sm text-dash-primary">
        mid-run fuel
      </div>
      <div className="mt-1.5 text-[10px] font-mono text-dash-muted">
        edit it, then Generate Briefs
      </div>
    </SimShell>
  );
}

export function BrainstormSuggestionsSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <BSChips />, label: 'AI proposes sub-angles', duration: D },
        { frame: <BSClick />, label: 'Click one to use it', duration: D },
        { frame: <BSPopulated />, label: 'The topic input fills in', duration: D },
      ]}
    />
  );
}
